import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  IconButton,
  MenuItem,
  Select,
  InputLabel,
  FormControl
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { updateOffer } from "../../../../services/pos/Tables";
import { getAllProducts } from "../../../../services/menuPage";

const EditOfferModal = ({ isOpen, onClose, initialData, onSuccess }) => {
  const [form, setForm] = useState({ ...initialData, items: initialData.items || [] });
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await getAllProducts();
        setProducts(Array.isArray(res) ? res : res.data || []);
      } catch (err) {
        console.error("❌ فشل في تحميل المنتجات:", err.message);
      }
    };
    fetchProducts();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...form.items];
    updatedItems[index][field] = value;
    setForm((prev) => ({ ...prev, items: updatedItems }));
  };

  const handleDeleteItem = (index) => {
    const updatedItems = form.items.filter((_, i) => i !== index);
    setForm((prev) => ({ ...prev, items: updatedItems }));
  };

  const handleAddItem = () => {
    const newItem = { product_id: "", price: 0, quantity: 1, note: "" };
    setForm((prev) => ({ ...prev, items: [...(prev.items || []), newItem] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateOffer({ ...form, itmes: form.items });
      alert("✅ تم التعديل بنجاح");
      if (onSuccess) onSuccess();
      onClose();
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 600,
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 4,
        borderRadius: 2,
        maxHeight: "90vh",
        overflow: "auto"
      }}>
        <Typography variant="h6" mb={2}>تعديل العرض</Typography>
        <form onSubmit={handleSubmit}>
          <TextField fullWidth label="اسم العرض" name="name" value={form.name || ""} onChange={handleChange} margin="normal" />
          <TextField fullWidth label="Tag العرض" name="name_tage" value={form.name_tage || ""} onChange={handleChange} margin="normal" />
          <TextField fullWidth label="الوصف" name="description" value={form.description || ""} onChange={handleChange} margin="normal" multiline />

          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField
              type="date"
              label="تاريخ البداية"
              name="start_date"
              value={form.start_date || ""}
              onChange={handleChange}
              margin="normal"
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              type="date"
              label="تاريخ النهاية"
              name="end_date"
              value={form.end_date || ""}
              onChange={handleChange}
              margin="normal"
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Box>

          <TextField fullWidth type="number" label="الخصم" name="discount" value={form.discount || 0} onChange={handleChange} margin="normal" />
          <TextField fullWidth type="number" label="السعر الإجمالي" name="total_price" value={form.total_price || 0} onChange={handleChange} margin="normal" />

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 3, mb: 1 }}>
            <Typography variant="subtitle1">الأصناف:</Typography>
            <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={handleAddItem}>إضافة صنف</Button>
          </Box>

          {form.items?.map((item, index) => (
            <Box key={index} sx={{ border: "1px solid #ccc", p: 2, mb: 1, borderRadius: 1 }}>
              <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
                <FormControl fullWidth>
                  <InputLabel id={`product-select-${index}`}>المنتج</InputLabel>
                  <Select
                    labelId={`product-select-${index}`}
                    value={item.product_id}
                    onChange={(e) => handleItemChange(index, "product_id", e.target.value)}
                    label="المنتج"
                  >
                    {products.map((product) => (
                      <MenuItem key={product.id} value={product.id}>{product.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  label="السعر"
                  type="number"
                  value={item.price}
                  onChange={(e) => handleItemChange(index, "price", e.target.value)}
                  fullWidth
                />
                <TextField
                  label="الكمية"
                  type="number"
                  value={item.quantity}
                  onChange={(e) => handleItemChange(index, "quantity", e.target.value)}
                  fullWidth
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <TextField
                  label="ملاحظة"
                  value={item.note || ""}
                  onChange={(e) => handleItemChange(index, "note", e.target.value)}
                  fullWidth
                  multiline
                />
                <IconButton onClick={() => handleDeleteItem(index)} color="error">
                  <DeleteIcon />
                </IconButton>
              </Box>
            </Box>
          ))}

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button type="submit" variant="contained" disabled={loading} color="primary">
              {loading ? <CircularProgress size={24} color="inherit" /> : "حفظ التعديلات"}
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};

export default EditOfferModal;
